// Class containing all API calls specifications
import axios from 'axios';

const baseResourceURL = window.location.host === 'knaufinsulation.mytravo.net'
  ? 'https://api.knaufinsulation.mytravo.net/'
  : 'https://api.knaufinsulationbeta.mytravo.net/';
const baseApiURL = window.location.host === 'knaufinsulation.mytravo.net'
  ? 'https://api.knaufinsulation.mytravo.net/api/v1/'
  : 'https://api.knaufinsulationbeta.mytravo.net/api/v1/';

const POST = 'POST';
const GET = 'GET';
const POST_FORM = 'POST-FORM';

const requestBuilder = (url, method, data, token) => {
  if (method === GET) {
    if (token) {
      return axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
    }
    return axios.get(url);
  } if (method === POST) {
    if (token) {
      return axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          accept: 'application/ld+json',
        },
      });
    }
    return axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/ld+json',
      },
    });
  } if (method === POST_FORM) {
    if (token) {
      return axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return axios({
      method: 'post',
      url,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  // We'll see if we need to handle more cases in the future.
};

const login = (username, password) => {
  const form = new FormData();

  form.append('username', username);
  form.append('password', password);
  form.append('email', username);
  return requestBuilder(`${baseApiURL}login`, POST_FORM, form, undefined);
};

const getToken = () => {
  const token = sessionStorage.getItem('USER_TOKEN');

  return Promise.resolve(token);
};

const api = {
  resourceURL: baseResourceURL,
  apiURL: baseApiURL,
  getToken,
  login,
  getProducts: () => new Promise((resolve) => {
    getToken().then((token) => {
      resolve(
        requestBuilder(`${baseApiURL}products?limit=0`, GET, undefined, token)
      );
    });
  }),
  getProductsTypes: () => new Promise((resolve, reject) => {
    getToken().then((token) => {
      resolve(
        requestBuilder(
          `${baseApiURL}productstype?limit=0`,
          GET,
          undefined,
          token
        )
      );
    });
  }),

  getPreSelect: () => new Promise((resolve, reject) => {
    getToken().then((token) => {
      resolve(
        requestBuilder(
          `${baseApiURL}preselect?limit=0`,
          GET,
          undefined,
          token
        )
      );
    });
  }),

  getWorkstypes: () => new Promise((resolve, reject) => {
    getToken().then((token) => {
      resolve(
        requestBuilder(
          `${baseApiURL}workstype?limit=0`,
          GET,
          undefined,
          token
        )
      );
    });
  }),
  addClient: data => new Promise((resolve, reject) => {
    getToken().then((token) => {
      resolve(
        requestBuilder(`${baseApiURL}register`, POST_FORM, data, token)
      );
    });
  }),
  sendMail: data => new Promise((resolve, reject) => {
    getToken().then((token) => {
      resolve(
        requestBuilder(`${baseApiURL}email-export`, POST_FORM, data, token)
      );
    });
  }),

  getRelProduct: data => new Promise((resolve, reject) => {
    getToken().then((token) => {
      resolve(
        requestBuilder(`${baseApiURL}relproductsproducts`, GET, data, token)
      );
    });
  }),

  ResetPassword: (data) => {
    const form = new FormData();
    form.append('email', data.email);
    return new Promise((resolve, reject) => {
      getToken().then((token) => {
        resolve(requestBuilder(`${baseApiURL}reset-password`, POST_FORM, form));
      });
    });
  },

  getPreselect: (r, isMono, height) => getToken().then((token) => {
    if (isMono) {
      return requestBuilder(
        `${baseApiURL}preselect?limit=0&attr=r,monobicouche&value=${r},1`,
        GET,
        null,
        token,
      );
    }

    return requestBuilder(
      `${baseApiURL}preselect?limit=0&attr=r,monobicouche,height&value=${r},2,${height}`,
      GET,
      null,
      token,
    );
  }),
};
export default api;



// WEBPACK FOOTER //
// ./src/services/Api.js